import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { updatePath } from './actions';

const HanwhaToggle = () => {
  const dispatch = useDispatch();
  const update = useCallback((...args) => dispatch(updatePath(...args)), [dispatch]);
  const hanwhaClickToMove = useSelector(
    ({ mapping: { preview: { hanwhaClickToMove: enabled } } }) => enabled,
  );
  const connectedCamera = useSelector(({ mapping: { connectedCamera: cam } }) => cam);

  return (
    <Button
      variant={hanwhaClickToMove ? 'outline-success' : 'outline-primary'}
      className="small"
      disabled={!connectedCamera}
      title="Hanwha: click preview to move via areazoom. Off uses ONVIF relative moves."
      onClick={() => update('preview.hanwhaClickToMove', !hanwhaClickToMove)}
    >
      Hanwha
    </Button>
  );
};

export default HanwhaToggle;
